import { Component, EventEmitter, Input, input, InputSignal, Output } from "@angular/core";
type CloseButtonType = "plain" | "square";

@Component({
  selector: "close-button",
  templateUrl: "./close-button.component.html",
})
export class CloseButtonComponent {
  @Input() type: CloseButtonType;
  customizedCloseIcon: InputSignal<string> = input("");
  @Input() isMatDialog: boolean = true;
  @Input() buttonClass: string = "btn-icon";
  @Output() closeClickedEvent = new EventEmitter<void>();

  handleClose() {
    if (!this.isMatDialog) {
      this.closeClickedEvent.emit();
    }
  }
}
